import { AfterViewInit, ChangeDetectorRef, Component, HostListener, Inject, Input, OnInit, PLATFORM_ID, TemplateRef, ViewChild } from '@angular/core'
import { PageService } from 'src/app/core/services/page.service'
import { LayoutBreakpoins } from '../../../interfaces'
import { ApiService } from '../../../core/services/api.service'
import { ChatState } from '../../../core/services/chat.service'
//import { DropDownListComponent } from '@syncfusion/ej2-angular-dropdowns'
import { NavigationEnd, Router, RouterLink } from '@angular/router'
import { filter } from 'rxjs/operators'
import { NGXLogger } from 'ngx-logger'
import * as _ from 'lodash'
import { isPlatformBrowser } from '@angular/common'
import { LoginService } from 'src/app/modules/account/services/api/login.service'
import { combineLatest, Observable } from 'rxjs'
import { environment } from 'src/environments/environment'
import { RouteDataService } from 'src/app/RouteDataService'
import { SharedDataService } from 'src/app/core/services/shared-data.service'
import { NgSelectComponent } from '@ng-select/ng-select';

enum SearchCategory {
  FAQ = 'FAQ',
  WhyUs = 'Why Us',
  CreditTools = 'Credit Tools',
  HomePage = 'Home Page',
}

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit,  AfterViewInit {
  // activateTemplate !: TemplateRef<any>;
  // @ViewChild('hsfs', { static: false})
  // hsfsTemplate !: TemplateRef<any>;
  // @ViewChild('default', { static: false})
  // defaultTemplate !: TemplateRef<any>;
  public activeTemplate : any = '';
  equipmentProviderInActive: boolean;
  dentalProviderInActive: boolean;
  public routeAccountValidation: any = 'account-activation';
  public captureRoute: any;
  dropdownPlaceholder: string;
  searchInputAttrs: any = {};
  isDropdownActive: boolean = false;
  constructor(
    private api: ApiService,
    private chatState: ChatState,
    private loginService: LoginService,
    public router: Router,
    public logger: NGXLogger,
    private cdr:  ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: object,
    public page: PageService,
    public myservice: RouteDataService,
    public sharedDataService: SharedDataService
  ) {
    //this.getRoute();
    //this.getRoute();
     /*  this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        console.log('XXXXX: ' + e.url);
     }
    }); */
    //this.getHeaderPages()
    this.loginService.authCheck()
    const routerNavigationData: Observable<NavigationEnd> = this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd)
    )
    combineLatest([this.loginService.isLoggedIn, routerNavigationData]).subscribe(([isLoggedIn, _router]) => {
      if (isLoggedIn === true) {
        this.showAccountText = true
        this.showLogoutText = false
      }
      if (isLoggedIn === true && _router.url.includes('account')) {
        this.showLogoutText = true
        this.showAccountText = false
        return
      }
      if (_router.url.includes('fraud-affidavit') || _router.url.includes('press')) {
        this.showBottomLinks = false
      } else {
        this.showBottomLinks = true
      }
      this.showLogoutText = false
    })


  }
  @Input() breakpoints: LayoutBreakpoins = {
    extraSmall: false,
    small: false,
    medium: false,
    large: true,
    extraLarge: false,
  }

  @Input() showBottomLinks = true
  showNav = false
  pages: any[] = []
  displayNavigation = true
  text: string

  results: string[]

  searchBox = false

  videos = []
  articles = []
  searchDataDesktop = []

  // search values
  searchVisibility = 'collapse'
  searchHeight = 0
  public searchData: any = []
  public searchDataMob: { [key: string]: any }[] = []
  // maps the appropriate column to fields property
  public fields: any = { groupBy: 'Category', text: 'Text', value: 'URL' }
    @ViewChild('search') searchDropdown!: NgSelectComponent;
    //public searchObj: DropDownListComponent
    public searchObj!: NgSelectComponent;

  public searchPopupHeight = '300px'
  public searchMobilePopupHeight = '30%'
  public providerUrl = environment.providerLink

  showLogoutText = false
  showAccountText = false
  skipClickOptions = false
  showLoginOptions = false

  ngOnInit() {

    try {
      this.getSearchOptions()
    } catch (err) {}
    // if (isPlatformBrowser(this.platformId)) {
    //   setTimeout(() => {
    //   }, 200)
    // }

 console.log('ImagePath:' + this.sharedDataService.assetsCdn('img/')  );

    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        console.log('Pass ' + e.url);
        //this.myservice.activeRoute$.next(e.url)
        this.myservice.updateRoute(e.url)
      }
    })
    
   this.activeTemplate = this.sharedDataService.getRoute()
   this.getHeaderPages()
   console.log('HEDAERTEMPLATE: ' + this.activeTemplate)

   
   this.equipmentProviderInActive = this.sharedDataService.getPortalType()
   this.dropdownPlaceholder = this.equipmentProviderInActive ? 'Search hspracticepay.com' : 'Search icreditworks.com';
  }

  ngAfterViewInit(){
    console.log('Init:: ' + this.router.url)
    switch (this.activeTemplate) {
      case "hsfs":
       this.routeAccountValidation = "hsfs/hsfs-account-activation"
        break;
      default:
        this.routeAccountValidation = "account-activation"
        break;
    }

//     setTimeout(() => {    
//        this.searchDropdown.focus();
//  this.searchDropdown.open();

//     },0);

    //this.myservice.updateRoute("/hsfs")
    /* this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        console.log('PASS ' + e.url);
        this.myservice.activeRoute$.next(e.url)

      }
    })
     */
/*     console.log('dddd: ' + this.routeAccountValidation)
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        console.log('Header Path: ' + e.url);
        this.captureRoute = e.url
         switch (true) {
          case this.captureRoute.indexOf('hsfs') > -1:
            // this.captureRoute = true
            // this.activateTemplate= this.hsfsTemplate;
            this.activeTemplate = 'hsfs'
            this.routeAccountValidation = "hsfs/hsfs-account-activation"
            break;
          default:
            //this.captureRoute = false
            //this.activateTemplate = this.defaultTemplate;
            this.activeTemplate = ''
            this.routeAccountValidation = "account-activation"
            break;
        }
        // switch (this.captureRoute) {
        //   case "/hsfs":
        //     this.routeAccountValidation = "hsfs/account-activation"
        //     break;
        //   case "default":
        //     this.routeAccountValidation = "/account-activation"
        //     break;
        // } 
      }
      this.getHeaderPages()

    });
    this.cdr.detectChanges(); */
  }


 /*  getRoute(){
    console.log('dddd: ' + this.routeAccountValidation)
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        console.log('Header Path: ' + e.url);
        this.captureRoute = e.url
         switch (true) {
          case this.captureRoute.indexOf('hsfs') > -1:
            // this.captureRoute = true
            // this.activateTemplate= this.hsfsTemplate;
            this.activeTemplate = 'hsfs'
            this.routeAccountValidation = "hsfs/hsfs-account-activation"
            break;
          default:
            //this.captureRoute = false
            //this.activateTemplate = this.defaultTemplate;
            this.activeTemplate = 'dental'
            this.routeAccountValidation = "account-activation"
            break;
        }
        // switch (this.captureRoute) {
        //   case "/hsfs":
        //     this.routeAccountValidation = "hsfs/account-activation"
        //     break;
        //   case "default":
        //     this.routeAccountValidation = "/account-activation"
        //     break;
        // } 
      }
      this.getHeaderPages()

    });
    //this.cdr.detectChanges();
  } */

  @HostListener('window:click')
  hostClick() {
    if (this.skipClickOptions) {
      this.skipClickOptions = false
      return
    }
    this.showLoginOptions = false
  }

  search(event) {
    this.logger.info(event.query)
  }

  dropDownOpen(event: Event) {
    this.displayNavigation = false
  }

  dropDownClose(event: Event) {
    this.displayNavigation = true
  }




onDropdownFocus() {
  this.isDropdownActive = true;
}

  onOpen() {
      this.isDropdownActive = true;
    this.dropdownPlaceholder = '';
    this.searchInputAttrs = {
      placeholder: 'e.g: faq'
    };
   
    setTimeout(() => {
      const panelItems = document.querySelector(
        '.ng-select.search-dropdown .ng-dropdown-panel-items.scroll-host'
      ) as HTMLElement;

      if (panelItems) {
        panelItems.style.maxHeight = 'none';
        panelItems.style.height = '100vh';

        panelItems.style.fontSize = '13px';
        panelItems.style.lineHeight = '26px';


        panelItems.style.fontFamily = 'inherit';
        panelItems.style.minHeight = '36px';
        panelItems.style.borderBottom = "0";
        panelItems.style.borderColor = "#b92626;";
        panelItems.style.color = "#000000de";
        panelItems.style.textIndent = "16px";
        panelItems.style.letterSpacing = "0.7px";
      }



      const panelItemsBg = document.querySelector(
        '.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-marked'
      ) as HTMLElement;

      if (panelItemsBg) {
        panelItemsBg.style.backgroundColor = '#f5f5f5';
      }


      const panelItemsBorderTop = document.querySelector(
        '.search-dropdown .ng-dropdown-panel .ng-dropdown-panel-items'
      );

      if (!panelItemsBorderTop) return;

      const groups = panelItemsBorderTop.querySelectorAll('.ng-optgroup');

      groups.forEach((group, index) => {
        if (index > 0) {
          (group as HTMLElement).style.borderTop = '1.2px solid #dcdcdc';
          (group as HTMLElement).style.paddingBottom = "6px";
        }
      });




      
    }, 0);
  }

  onClose() {
     this.isDropdownActive = false;
    this.dropdownPlaceholder = this.equipmentProviderInActive ? 'Search hspracticepay.com' : 'Search icreditworks.com';
    this.searchInputAttrs = {
      placeholder: ''
    };
  }


/*   searchChange() {
    const val: string = this?.searchObj?.value as any

    this.logger.info(val)
    if (!val || val.indexOf('#') === -1) {
      return
    }
    const [nav, part] = val.split('#')
    this.toggleSearch()
    this.page.goAndScroll(nav, part)
  } */

  searchMobileChange(event?: any) {
    const val = event ? event.URL : "" as any;

    this.logger.info(val)
    if (!val || val.indexOf('#') === -1) {
      return
    }
    const [nav, part] = val.split('#')
    this.closeNavAndGo(nav, part)
  }

  fetchVideos() {
    return this.api
      .getWhyUsPage()
      .toPromise()
      .then((data) => {
        const videos = data.data.attributes.videos.videos
        this.videos = videos.map((x) => ({
          Category: 'Videos',
          header: x.header,
          title: x.title,
          Text: `${x.header} ${x.title}`,
          URL: '/why-us#videosContainer',
        }))
        this.searchData = this.searchData.concat(this.videos)
        this.searchDataMob = this.searchData
      })
      .catch((err) => {
        this.logger.error(err)
      })
  }

  fetchArticles() {
    return this.api
      .getArticles()
      .toPromise()
      .then((data) => {
        const articles = data.data[0].items
        this.articles = articles.map((x) => ({
          Category: 'Articles',
          cat: x.category,
          Text: x.title,
          URL:
            '/article/' +
            x.title
              .toLowerCase()
              .replace(/[\.\,\!\?]/g, '')
              .replace(/\s/g, '-'),
        }))
        this.searchData = this.searchData.concat(this.articles)
        this.searchData = this.sortData(this.searchData)
        this.searchData = this.searchData.map((x) => {
          x.Category = x.Category.toUpperCase()
          return x
        })
      })
      .catch((err) => {
        this.logger.error(err)
      })
  }

  getSearchOptions() {
    this.api.getSearchOptions().subscribe(
      (data: any) => {
        let res = data.data.map(t => t.attributes)
        this.sortKeysValuesByOrder(res)
        this.searchData = this.searchData.concat(res)
        this.searchDataDesktop = this.searchData
        if (this.breakpoints.extraSmall) {
          this.searchData = this.sortData(this.searchData)
          this.searchData = this.searchData.map((x) => {
            x.Category = x.Category.toUpperCase()
            return x
          })
          this.searchDataMob = this.searchData
          this.fetchVideos()
          this.fetchArticles()
        }
      },
      (error: any) => {
        console.error(error)
      }
    )
  }

  sortData(data: any[]) {
    const sortOrderList = ['Home', 'Why iCreditWorks', 'Experience', 'Policies', 'Articles', 'Videos']
    const sortedCollection = _.sortBy(data, (item) => {
      return sortOrderList.indexOf(item.Category)
    })
    return sortedCollection
  }

  sortKeysValuesByOrder(data) {
    data = _.sortBy(data, (x) => x.order)
  }

  toggleNavSelectors(): boolean {
         if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    if (!document.querySelector('#nav__toggler')) {
      return false
    }
    document.querySelector('#nav__toggler').classList.toggle('open')
    if (!document.querySelector('#mobileHeader')) {
      return false
    }
    document.querySelector('#mobileHeader').classList.toggle('header_open')
    this.showNav = !this.showNav
    document.body.style.overflow = this.showNav ? 'hidden' : ''
    return true
  }

  closeNavAndGo(nav, part) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const success = this.toggleNavSelectors()
    if (!success) {
      return
    }
    const timeBeforeToggle = 100
    setTimeout(() => {
      const el = document.querySelectorAll('.header__link_secondary')
      el.forEach((e: HTMLElement) => {
        const ee: HTMLElement = e
        ee.onclick = () => {
          this.toggleNav()
        }
      })
      this.router.navigate([nav])
      this.page.scrollTo(part, 'center', 100).then(() => {
        const elem = document.getElementById('search_list_popup')
        elem?.remove()
      })
    }, timeBeforeToggle)
  }

  toggleNav() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const success = this.toggleNavSelectors()
    if (!success) {
      return
    }
    const timeBeforeToggle = 100
    setTimeout(() => {
      const el = document.querySelectorAll('.header__link_secondary')
      this.logger.info('timeout')
      el.forEach((e: HTMLElement) => {
        this.logger.info('foreach')
        const ee: HTMLElement = e
        ee.onclick = () => {
          this.toggleNav()
        }
      })
    }, timeBeforeToggle)
  }
  dropdownToggle(event: any) {
    event.currentTarget.nextSibling.classList.toggle('header__navigation_hidden')
    event.currentTarget.nextSibling.classList.toggle('header__navigation_open')
    event.currentTarget.lastChild.firstChild.classList.toggle('arrow_down')
    event.currentTarget.lastChild.firstChild.classList.toggle('arrow_up')
  }

  getHeaderPages() {
    // this.api.getSearchOptions().subscribe(
    //   (data: any) => {
    //     let res = data.data.map(t => t.attributes)
    //     this.sortKeysValuesByOrder(res)
    //     this.searchData = this.searchData.concat(res)
    //     this.searchDataDesktop = this.searchData
    //     this.searchData = this.sortData(this.searchData)
    //     this.fetchVideos()
    //     this.fetchArticles()
    //     })
    // this.api.getPages().subscribe(
    //   (res: any[]) => {

    let res = []
    res = [{ "type": "header", "title": "Experience", "header_sort_order": 3, "footer_sort_order": null, "id": "credit-tools", "uri": "/pages/credit-tools" }, { "type": null, "title": "Answers to Frequently Asked Questions ", "header_sort_order": null, "footer_sort_order": null, "id": "faq", "uri": "/pages/faq" }, { "type": null, "title": null, "header_sort_order": null, "footer_sort_order": null, "id": "footer", "uri": "/pages/footer" }, { "type": "header", "title": "Check Loan Options", "header_sort_order": 1, "footer_sort_order": null, "id": "home-page", "uri": "/pages/home-page" }, { "type": null, "title": null, "header_sort_order": null, "footer_sort_order": null, "id": "policies", "uri": "/pages/policies" }, { "type": null, "title": null, "header_sort_order": null, "footer_sort_order": null, "id": "press-news", "uri": "/pages/press-news" }, { "type": "header", "title": "Why iCreditWorks", "header_sort_order": 2, "footer_sort_order": null, "id": "why-us", "uri": "/pages/why-us" }]

    // switch (this.activeTemplate) {
    //   case "hsfs":
    //     console.log('HSFS:: BOOM')
    //     res = [{ "type": "header", "title": "Experience", "header_sort_order": 3, "footer_sort_order": null, "id": "credit-tools", "uri": "/pages/hsfs/hsfs-credit-tools" }, { "type": null, "title": "Answers to Frequently Asked Questions ", "header_sort_order": null, "footer_sort_order": null, "id": "faq", "uri": "/pages/hsfs/hsfs-faq" }, { "type": null, "title": null, "header_sort_order": null, "footer_sort_order": null, "id": "footer", "uri": "/pages/hsfs/hsfs-footer" }, { "type": "header", "title": "Check Loan Options", "header_sort_order": 1, "footer_sort_order": null, "id": "home-page", "uri": "/pages/hsfs/hsfs-home-page" }, { "type": null, "title": null, "header_sort_order": null, "footer_sort_order": null, "id": "policies", "uri": "/pages/hsfs/hsfs-policies" }, { "type": null, "title": null, "header_sort_order": null, "footer_sort_order": null, "id": "press-news", "uri": "/pages/hsfs/hsfs-press-news" }, { "type": "header", "title": "Why iCreditWorks", "header_sort_order": 2, "footer_sort_order": null, "id": "why-us", "uri": "/pages/hsfs/hsfs-why-us" }]
    //     break;
    //   default:
    //     console.log('HSFS:: DEFAULT')
    //     res = [{ "type": "header", "title": "Experience", "header_sort_order": 3, "footer_sort_order": null, "id": "credit-tools", "uri": "/pages/credit-tools" }, { "type": null, "title": "Answers to Frequently Asked Questions ", "header_sort_order": null, "footer_sort_order": null, "id": "faq", "uri": "/pages/faq" }, { "type": null, "title": null, "header_sort_order": null, "footer_sort_order": null, "id": "footer", "uri": "/pages/footer" }, { "type": "header", "title": "Check Loan Options", "header_sort_order": 1, "footer_sort_order": null, "id": "home-page", "uri": "/pages/home-page" }, { "type": null, "title": null, "header_sort_order": null, "footer_sort_order": null, "id": "policies", "uri": "/pages/policies" }, { "type": null, "title": null, "header_sort_order": null, "footer_sort_order": null, "id": "press-news", "uri": "/pages/press-news" }, { "type": "header", "title": "Why iCreditWorks", "header_sort_order": 2, "footer_sort_order": null, "id": "why-us", "uri": "/pages/why-us" }]
    //     break;
    // }
     
    this.pages = res
      .filter((el) => !!el.header_sort_order)
      .sort((a, b) => a.header_sort_order - b.header_sort_order)
      //     console.log(this.pages)
    //   },
    //   (error: any) => {
    //     console.error(error)
    //   }
    // )
  }

  toggleConsumerLogin() {
    if (this.breakpoints.large || this.breakpoints.extraLarge) {
      this.router.navigate(['', { outlets: { modal: ['account'] } }], { skipLocationChange: true })
      if(this.equipmentProviderInActive){
        //this.sharedDataService.dispAmortization$.next(false)
        this.sharedDataService.dispAmortization$.next(true)
      }
    } else {
      this.router.navigate(['/getphonenumber'] , { skipLocationChange: true})
    }
  }


  toggleChat() {
    this.chatState.toggleChat(true)
    this.toggleNav()
  }

  toggleSearch() {
    this.searchBox = !this.searchBox
    // if (this.searchHeight !== null) {
    //   this.searchVisibility = 'inherit'
    //   this.displayNavigation = false;
    //   this.searchHeight = null
    // }
    // else {
    //   this.searchVisibility = 'collapse'
    //   this.displayNavigation = true;
    //   this.searchHeight = 0
    // }
  }

  modPageUri(uri: string) {
    const correctUri = uri.replace('/pages', '')
    if (correctUri.includes('home')) {
      return ''
    }
    return correctUri
  }

  closeEvent() {
    this.searchBox = !this.searchBox
  }

  clickLogout() {
   // this.sharedDataService.dispAmortization$.next(false)
    this.loginService.logout().subscribe((res) => {
      this.router.navigateByUrl('/')
      window.location.reload()
    
    })
  }
  clickLogin() {
    if (this.showAccountText) {
      if(this.equipmentProviderInActive){
       // this.sharedDataService.dispAmortization$.next(false)
        this.sharedDataService.dispAmortization$.next(true)
      }
      this.router.navigate(['', { outlets: { modal: ['account'] } }])
      return
    }
    this.skipClickOptions = true
    this.showLoginOptions = true
   }
}
